import dynamic from "next/dynamic"
import styled from "styled-components"
import loaderLottie from "../public/animation/shopLoader.json"

const Lottie = dynamic(() => import("lottie-react"), { ssr: false })

const StyledLoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  inset: 0;
  z-index: 5;
  position: fixed;
`
const StyledbackDrop = styled.div`
  position: absolute;
  inset: 0;
  background-color: rgba(16, 16, 16, 0.4);
  backdrop-filter: blur(5.5px);
`
const StyledLottie = styled(Lottie)`
  width: 298px;
  height: 167px;
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 500px;
    height: 281px;
  }
`

const ShopLoader = ({ className }: { className?: string }) => {
  return (
    <StyledLoaderWrapper className={className}>
      <StyledbackDrop />
      <StyledLottie animationData={loaderLottie} />
    </StyledLoaderWrapper>
  )
}

export default ShopLoader
